import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/debt-consolidation',
  component: () => import('../../routes/DebtConsolidation.svelte'),
  card: {
    id: 'debt-consolidation',
    title: 'Debt Consolidation',
    description: 'Compare consolidating multiple debts into one loan to save on interest and simplify payments.',
    icon: 'account_balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/debt-consolidation',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Debt Consolidation Calculator – Compare Loan Consolidation Savings',
    description: 'Free debt consolidation calculator to compare the cost of paying off multiple debts individually vs. consolidating into a single loan. See how much you could save on interest.',
  },
};

export default meta;
